import { useState, useEffect } from "react";
import { X, Cookie } from "lucide-react";
import { useT } from "../hooks/useT";

const COOKIE_KEY = "livewifi_cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const t = useT();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = (level) => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ level, date: new Date().toISOString() }));
    // Update Google Consent Mode based on user choice
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      if (level === "all") {
        window.gtag("consent", "update", {
          ad_storage: "granted",
          ad_user_data: "granted",
          ad_personalization: "granted",
          analytics_storage: "granted",
        });
      } else {
        window.gtag("consent", "update", {
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
          analytics_storage: "denied",
        });
      }
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-in slide-in-from-bottom"
      style={{ animation: "slideUp .4s ease-out" }}
    >
      <div className="max-w-4xl mx-auto bg-[#141414] border border-white/10 rounded-2xl p-6 md:p-8 shadow-[0_-8px_30px_rgba(0,0,0,0.5)]">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex w-10 h-10 rounded-lg bg-[#7DD500]/10 items-center justify-center flex-shrink-0 mt-0.5">
            <Cookie className="w-5 h-5 text-[#7DD500]" strokeWidth={1.5} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-4 mb-3">
              <h3 className="text-white font-bold tracking-tight">{t("cookie_title")}</h3>
              <button
                onClick={() => accept("essential")}
                className="text-[#A1A1AA] hover:text-white transition-colors flex-shrink-0"
                aria-label="Cerrar"
                data-testid="cookie-close-btn"
              >
                <X className="w-5 h-5" strokeWidth={1.5} />
              </button>
            </div>
            <p className="text-[#A1A1AA] text-sm leading-relaxed mb-5">
              {t("cookie_text")}{" "}
              <button className="text-[#7DD500] underline underline-offset-2 hover:text-[#8DF000]">
                {t("cookie_policy")}
              </button>.
            </p>
            <div className="flex flex-wrap gap-3">
              <button
                onClick={() => accept("all")}
                data-testid="cookie-accept-all"
                className="bg-[#7DD500] text-[#0A0A0A] font-bold text-sm rounded-lg px-6 py-2.5 hover:bg-[#8DF000] transition-all"
              >
                {t("cookie_accept_all")}
              </button>
              <button
                onClick={() => accept("essential")}
                data-testid="cookie-accept-essential"
                className="border border-white/20 text-white font-bold text-sm rounded-lg px-6 py-2.5 hover:border-[#7DD500] hover:text-[#7DD500] transition-all"
              >
                {t("cookie_only_essential")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
